import {CdkTextareaAutosize} from '@angular/cdk/text-field'
import {Component, inject, OnInit} from '@angular/core'
import {FormControl, ReactiveFormsModule} from '@angular/forms'
import {MatFormField, MatLabel} from '@angular/material/form-field'
import {MatInput} from '@angular/material/input'
import {debounceTime} from 'rxjs/operators'
import {StaticDataService} from '../../../services/static-data.service'
import {getTakeUntilDestroyed} from '@sparbanken-syd/sparbanken-syd-theme'

@Component({
  selector: 'spb-comments',
  templateUrl: './comments.component.html',
  styleUrls: ['./comments.component.scss'],
  imports: [
    MatFormField,
    MatLabel,
    CdkTextareaAutosize,
    MatInput,
    ReactiveFormsModule
  ]
})
export class CommentsComponent implements OnInit {
  public comments = new FormControl()

  private readonly staticDataService = inject(StaticDataService)

  private readonly takeUntilDestroyed = getTakeUntilDestroyed()

  public ngOnInit(): void {
    this.comments.valueChanges.pipe(
      debounceTime(1000)
    ).subscribe((val: string) => {
      this.staticDataService.comment$.next(val)
    })

    this.staticDataService.comment$
      .pipe(this.takeUntilDestroyed())
      .subscribe((comment: string) => {
        this.comments.setValue(comment, {emitEvent: false})
      })
  }
}
